/**
 * Вкладка «Справочники» раздела «Компания» (AK-527, AK-546 ч.2).
 *
 * Тенантских справочников больше одного: культуры и названия тех.операций.
 * Каждый из них — это ПАРА экранов (AK-546): «Справочник» (список для
 * ежедневной работы) и «Интеграции и импорт» (разбор порций, разовая
 * настройка). Пару собирает `CatalogSection`; здесь — только переключатель
 * между самими справочниками.
 *
 * Очередь у каждого справочника СВОЯ: культуры разбираются отдельно от
 * тех.операций, общей очереди «по всем справочникам» нет (решение founder
 * 05.08, ADR-064 §2.8 — таблица общая, экраны раздельные).
 */
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CatalogSection } from './CatalogSection';
import { TenantCatalogListPage } from './TenantCatalogListPage';
import { CompanyOpTypesPage } from './CompanyOpTypesPage';

export function CompanyReferencePanel() {
  return (
    <Tabs defaultValue="crops" className="flex flex-col gap-4">
      <TabsList className="self-start">
        <TabsTrigger value="crops">Культуры</TabsTrigger>
        <TabsTrigger value="operation-types">Типы операций</TabsTrigger>
      </TabsList>
      <TabsContent value="crops">
        <CatalogSection entityType="crop">
          <TenantCatalogListPage />
        </CatalogSection>
      </TabsContent>
      <TabsContent value="operation-types">
        <CatalogSection entityType="operation_type">
          <CompanyOpTypesPage />
        </CatalogSection>
      </TabsContent>
    </Tabs>
  );
}

export default CompanyReferencePanel;
